import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit, OnDestroy {
  entityHashId: string = '';
  entityName: string = '';
  datalength!: number
  feedbackList: any = [];
  public page: number = 1;
  private _apiSubscription: Subscription;
  public loader: boolean = false;
  constructor(private _navService: NavigationService, private _apiService: ApiService, private router: Router, private loaderservice: LoaderServiceService, private route: ActivatedRoute) {
    this._navService.hideSidebarAndNav = false;
        
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_FEEDBACKS){
        console.log(resData);
        this.datalength = resData.result ? resData.result[0].rating_count : 0
        this.feedbackList = resData.result ? resData.result : [];
      }
      this.loader = false;
      this.loaderservice.showLoader = false
    })
   }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      this.entityName = data.entityName

      
    })
    this.loader = true;
    this.loaderservice.showLoader = true
    this._apiService.getFeedBacks(this.entityHashId,this.page.toString())
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    
    this._apiService.getFeedBacks(this.entityHashId,this.page.toString())
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

  opencontact(){
    this.router.navigate(['/contact-us']);
  }
getStarFillLevels(rating: number = 0): number[] {
  const fillLevels: number[] = [];

  for (let i = 0; i < 5; i++) {
    const starRating = rating - i;

    if (starRating >= 1) {
      fillLevels.push(100);
    } else if (starRating > 0) {
      fillLevels.push(starRating * 100); // precise fractional part
    } else {
      fillLevels.push(0);
    }
  }
  // console.log('filllevel', fillLevels);
  
  return fillLevels;
}


}
